import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return "Conditions générales d'utilisation topela"
}